import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function PeopleTalk(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, sx, viewBox, "data-tidal": "TidalIllustration", "data-tidal-illustration": "PeopleTalk", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M12.75 33c2.4853 0 4.5-2.0147 4.5-4.5s-2.0147-4.5-4.5-4.5-4.5 2.0147-4.5 4.5 2.0147 4.5 4.5 4.5Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M12.75 33c-1.9891 0-3.89678.7902-5.3033 2.1967C6.04018 36.6032 5.25 38.5109 5.25 40.5h15c0-1.9891-.7902-3.8968-2.1967-5.3033C16.6468 33.7902 14.7391 33 12.75 33Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M35.25 33c2.4853 0 4.5-2.0147 4.5-4.5s-2.0147-4.5-4.5-4.5-4.5 2.0147-4.5 4.5 2.0147 4.5 4.5 4.5Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M35.25 33c-1.9891 0-3.8968.7902-5.3033 2.1967C28.5402 36.6032 27.75 38.5109 27.75 40.5h15c0-1.9891-.7902-3.8968-2.1967-5.3033C39.1468 33.7902 37.2391 33 35.25 33ZM24 35.25c2.4853 0 4.5-2.0147 4.5-4.5s-2.0147-4.5-4.5-4.5-4.5 2.0147-4.5 4.5 2.0147 4.5 4.5 4.5Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M24 35.25c-1.9891 0-3.8968.7902-5.3033 2.1967C17.2902 38.8532 16.5 40.7609 16.5 42.75h15c0-1.9891-.7902-3.8968-2.1967-5.3033C27.8968 36.0402 25.9891 35.25 24 35.25Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M14.25 5.25H3.75c-.39782 0-.77936.15804-1.06066.43934-.2813.2813-.43934.66284-.43934 1.06066v6c0 .3978.15804.7794.43934 1.0607s.66284.4393 1.06066.4393h.75l3 3v-3h6.75c.3978 0 .7794-.158 1.0607-.4393s.4393-.6629.4393-1.0607v-6c0-.39782-.158-.77936-.4393-1.06066-.2813-.2813-.6629-.43934-1.0607-.43934Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M12 10.5H6c-.19891 0-.38968-.079-.53033-.2197C5.32902 10.1397 5.25 9.94891 5.25 9.75c0-.19891.07902-.38968.21967-.53033C5.61032 9.07902 5.80109 9 6 9h6c.1989 0 .3897.07902.5303.21967.1407.14065.2197.33142.2197.53033 0 .19891-.079.3897-.2197.5303-.1406.1407-.3314.2197-.5303.2197Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M33.75 7.5h10.5c.3978 0 .7794.15804 1.0607.43934S45.75 8.60218 45.75 9v6c0 .3978-.158.7794-.4393 1.0607s-.6629.4393-1.0607.4393h-.75l-3 3v-3h-6.75c-.3978 0-.7794-.158-1.0607-.4393S32.25 15.3978 32.25 15V9c0-.39782.158-.77936.4393-1.06066.2813-.2813.6629-.43934 1.0607-.43934Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M42 12.75h-6c-.1989 0-.3897-.079-.5303-.2197-.1407-.1406-.2197-.3314-.2197-.5303 0-.1989.079-.3897.2197-.5303.1406-.1407.3314-.2197.5303-.2197h6c.1989 0 .3897.079.5303.2197.1407.1406.2197.3314.2197.5303 0 .1989-.079.3897-.2197.5303-.1406.1407-.3314.2197-.5303.2197Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M27 12.75h-6c-.7956 0-1.5587.3161-2.1213.8787C18.3161 14.1913 18 14.9544 18 15.75v1.5c0 .7956.3161 1.5587.8787 2.1213.5626.5626 1.3257.8787 2.1213.8787l3 3v-3h3c.7956 0 1.5587-.3161 2.1213-.8787.5626-.5626.8787-1.3257.8787-2.1213v-1.5c0-.7956-.3161-1.5587-.8787-2.1213-.5626-.5626-1.3257-.8787-2.1213-.8787Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M27 17.25h-6c-.1989 0-.3897-.079-.5303-.2197-.1407-.1406-.2197-.3314-.2197-.5303 0-.1989.079-.3897.2197-.5303.1406-.1407.3314-.2197.5303-.2197h6c.1989 0 .3897.079.5303.2197.1407.1406.2197.3314.2197.5303 0 .1989-.079.3897-.2197.5303-.1406.1407-.3314.2197-.5303.2197Z",
        fill: theme.vars.palette.primary.dark
      }
    )
  ] });
}
PeopleTalk.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "PeopleTalk"
};
validateTidalLicense();
export {
  PeopleTalk
};
//# sourceMappingURL=PeopleTalk.js.map
